import React, { useState,useEffect } from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const HeaderStyle = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  background-color: #444;
  z-index:1;
  color: rgb(252, 221, 155);
  align-items: center;
  display: grid;
  grid-template-columns: 0.9fr 1fr;
  @media (max-width: 1100px) {
    grid-template-columns: 1fr 80px;
  }
`
const LinksStyle = styled.div`
  display: flex;
  @media (max-width: 1100px) {
    display: none;
  }
`
const SiteTitle = styled.h3`
  text-align: center;
  margin: auto;
`
const SiteLinks = styled(Link)`
  text-decoration: none;
  padding: 10px 15px;
  color: rgb(252, 221, 155);
  margin: auto;
  text-align: center;
`
const ToggleButton = styled.div`
  margin: 5px;
  border-radius: 10%;
  background: rgba(252, 221, 155, 0.4);
  height: 45px;
  width: 55px;
  @media (min-width: 1100px) {
    display: none;
  }
`
const ToggleLine = styled.div`
  background-color: #444;
  border-radius: 20%;
  margin: 10px auto;
  height: 2px;
  width: 50%;
`
const ToggleGrid = styled.div`
    grid-column: 1/3;
    display: grid;
    margin: auto;
`;
const ToggleLinks = styled(Link)`
  text-align: center;
  text-decoration: none;
  color: rgb(252, 221, 155);
  margin: 20px;
`

const Header = () => {
  const [toggleButton, setToggleButton] = useState(false)

  const toggle = () => {
    setToggleButton(toggleButton => !toggleButton)
  }
  useEffect (() => {
    setToggleButton(true)
  },[])
  const linksName = [
    "Home",
    "About",
    "Introduction",
    "CATE Journal",
    "Class Schedule",
    "SNOC Media",
    "Meditation",
    "Contact",
  ]
  const linksList = [
    "",
    "about",
    "introduction",
    "journal",
    "schedule",
    "media",
    "meditation",
    "contact",
  ]

  return (
    <HeaderStyle>
      <SiteTitle>The School of the Natural Order </SiteTitle>
      <LinksStyle>
        {linksName.map((link, i) => (
          <SiteLinks to={`/${linksList[i]}`} key={`${link}-nav`}>{link}</SiteLinks>
        ))}
      </LinksStyle>
      <ToggleButton onClick={toggle}>
        <ToggleLine />
        <ToggleLine />
        <ToggleLine />
      </ToggleButton>
      {toggleButton ? (<></>): (
        <ToggleGrid>
          {linksName.map((link, i) => (
            <ToggleLinks to={`/${linksList[i]}`} onClick={toggle} key={`${link}-nav-toggle`}>{link}</ToggleLinks>
          ))}
        </ToggleGrid>
      )}
    </HeaderStyle>
  )
}
export default Header
